import Vue from 'vue'
import VModal from 'vue-js-modal'
import i18n from '../plugins/i18n'

  if (!window.VModalRegistered) {
      Vue.use(VModal, { dynamic: true })
      window.VModalRegistered = true
  };

new Vue({
    i18n,
    el: '#reset-password',

    data() {
        return {
            resetPasswordForm: {clientId: null},
            resetPasswordSuccess: false
        }
    },

    created() {
        const translateEl = document.getElementById('translates-login')
        if (translateEl) {
            this.$i18n.setLocaleMessage('cs', JSON.parse(translateEl.innerHTML))
        }
      console.log("created")
    },

    methods: {
        openResetPasswordDialog() {
            this.$modal.show('reset-password-dialog')
        },

        closeResetPasswordDialog() {
            this.$modal.hide('reset-password-dialog')
        },

        async resetPassword() {
            if (this.resetPasswordForm.clientId) {
                try {
                    const {default: axios} = await import('axios')
                    const {API_URL} = await import('../utils/consts')
                    const {data: {records: {message}}} = await axios.post(`${API_URL}/renewPassword/createToken`, {client_id: this.resetPasswordForm.clientId}, {headers: {'content-type': 'application/json'}})
                    this.resetPasswordSuccess = message

                    // Redirect to lost-password-send page with identificator parameter
                    window.location.href = `/contact/lost-password-send?identificator=${encodeURIComponent(this.resetPasswordForm.clientId)}`
                } catch (e) {
                    const {ErrorModal} = await import(/* webpackPrefetch: true */'../Modals/ErrorModal')
                    ErrorModal.show(this, this.$i18n.t(e.response.data.errors ? `error.${e.response.data.errors.message}` : 'error.somethingWrong'))
                }
            }
        }
    }
});
